import { Navigate } from 'react-router-dom';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../hooks/useAuth';

export default function LoginPage() {
  const { user, isOperator, signInWithEmail, loading } = useAuth();
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const normalizedId = loginId.trim().toLowerCase().replace(/@.*/, '');
      if (!normalizedId) {
        throw new Error('invalid-id');
      }
      const email = `${normalizedId}@drsfarm.jp`;
      await signInWithEmail(email, password);
    } catch (err) {
      setError('ログインに失敗しました。IDまたはパスワードを確認してください。');
    } finally {
      setSubmitting(false);
    }
  }

  if (loading) return <p>読み込み中...</p>;
  if (user) return <Navigate to={isOperator ? '/admin' : '/me'} replace />;

  return (
    <>
      <Helmet><title>Drs.Farm | ログイン</title></Helmet>
      <section className="auth-card">
        <h1>ログイン</h1>
        <p>運営/農家共通ログインです。IDとパスワードでログインしてください。</p>
        <form className="form-grid" onSubmit={handleSubmit}>
          <label htmlFor="loginId">
            ID
            <input
              id="loginId"
              name="loginId"
              type="text"
              autoComplete="username"
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
              placeholder="例: taro01"
              required
            />
          </label>
          <p className="hint">IDのみ入力してください。</p>
          <label htmlFor="password">
            パスワード
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          {error ? <p className="error-text">{error}</p> : null}
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? 'ログイン中...' : 'ログイン'}
          </button>
        </form>
      </section>
    </>
  );
}
